import { render, staticRenderFns } from "./unsubscribe.vue?vue&type=template&id=1b069424&scoped=true"
import script from "./unsubscribe.vue?vue&type=script&lang=js"
export * from "./unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./unsubscribe.vue?vue&type=style&index=0&id=1b069424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b069424",
  null
  
)

export default component.exports